module.exports = __webpack_public_path__ + "static/img/question-circle-outlined.b96f93cd.svg";